import UpdateShopPaymentRequestModelBase from '../_generated/modelBases/update-shop-payment-request-model-base';

export default class UpdateShopPaymentRequestModel extends UpdateShopPaymentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
